var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNotification = function SvgNotification(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 18,
    "data-width-72": 53,
    viewBox: "0 0 11.7 13.7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.317 1.356a.5.5 0 0 0-.958 0 5 5 0 0 1 .958 0m-1.979.2V1.5a1.5 1.5 0 0 1 3 0v.056A5.17 5.17 0 0 1 11.005 6.5v2.427a1.494 1.494 0 0 1-.834 2.74h-2.5v.166a1.833 1.833 0 1 1-3.666 0v-.166h-2.5a1.494 1.494 0 0 1-.834-2.74V6.5a5.17 5.17 0 0 1 3.667-4.944m.667 10.277v-.166H6.67v.166a.833.833 0 0 1-1.666 0m5.166-1.166H1.505a.5.5 0 0 1-.167-.967.51.51 0 0 0 .333-.473V6.5a4.167 4.167 0 1 1 8.334 0v2.727a.51.51 0 0 0 .333.473.5.5 0 0 1-.167.967",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNotification);
export default ForwardRef;